var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg-icon',{attrs:{"name":'icons/' + _vm.cleanUpIconName(_vm.icon)}})
}
var staticRenderFns = []

export { render, staticRenderFns }